import { Routes, RouterModule } from "@angular/router";
import { ScanPointComponent } from "./components/scanpoint.component";
import { ScanPointConfigComponent } from "./scanpointconfig/scan-point-config.component";
import { TimeScanningComponent } from "./time-scanning/time-scanning.component";
import { TimeStampScanningComponent } from "./timestampscanning/time-stamp-scanning.component";
import { AuthguardService } from "../master/services";

export const ScanPointRoutes: Routes = [
	// { path: '', redirectTo: '/ScanPoint/', pathMatch: 'full' },
	// { path: 'scantime', data: { title: 'Time Stamp Scanning' }, component: TimeStampScanningComponent }, //OLD
	{
		path: "scantime",
		data: { title: "Time Stamp Scanning" },
		component: TimeScanningComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "scanconfig",
		data: { title: "ScanPoint Configuration" },
		component: ScanPointConfigComponent,
		canActivate: [AuthguardService],
	},
];
